
import { isAppUsing } from '@@/bits/flip'
import OzRelativeTime from '@@/library/v4/components/OzRelativeTime.vue'
import { n__ } from '@@/bits/intl'
import { transformCurrentUrl } from '@@/bits/location'
import { isRegistered } from '@@/bits/user_model'
import { Action, Component, Getter, namespace, Vue } from '@@/bits/vue'
import OzBadge, { OzBadgeColorScheme, OzBadgeSizePreset } from '@@/library/v4/components/OzBadge.vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import { uniq } from 'lodash-es'
import type { Post, User } from '@@/types'

@Component({
  components: {
    OzBaseButton,
    OzBadge,
    OzRelativeTime,
  },
})
export default class SurfaceBuilder extends Vue {
  @Getter builder!: User
  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter isMap!: boolean
  @Getter wallUpdatedAt!: string
  @Getter isMobileLayout!: boolean
  @Getter isTemplate!: boolean
  @Getter skinAccentColorAsRGB!: string | null
  @Getter skinAccentTextColor!: 'black' | 'white' | null
  @Action showContributorsList!: () => void
  @namespace('post').Getter postsArray!: Post[]

  OzBadgeColorScheme = OzBadgeColorScheme
  OzBadgeSizePreset = OzBadgeSizePreset
  isAppUsing = isAppUsing

  get isSkinColorAvailable(): boolean {
    return !!this.skinAccentColorAsRGB && !!this.skinAccentTextColor
  }

  get bgColorScheme(): 'light' | 'dark' {
    return this.isMap && !this.isMobileLayout ? this.colorScheme : this.backgroundLuminance
  }

  get isBuilderRegistered(): boolean {
    return isRegistered(this.builder)
  }

  get builderProfileUrl(): string {
    return transformCurrentUrl({}, { path: this.builder.username })
  }

  get contributorCount(): number {
    const authorIds = this.postsArray.map((p) => p.author_id)
    const nonBuilderAuthors = authorIds.filter((id) => id !== this.builder.id)
    return uniq(nonBuilderAuthors).length
  }

  get contributorText(): string {
    return n__('%{num} contributor', '%{num} contributors', this.contributorCount, { num: this.contributorCount })
  }
}
